import {sendMessageToNative} from "../utility/ApptoNativeBridge"
/**
 * @function webview時にキャンペーン詳細ページ内のリンクボタンデータを送信する関数
 */
function LinkClickSendData() {
  const ApptoWebPath = location.pathname
  const isWebView = ApptoWebPath.includes("/app/apptoweb/")

  // WebViewURLでなければ、何もせずに終了
  if (!isWebView) {
    return;
  }

  const buttonList = document.querySelectorAll('[data-controll="button"]');
  const locationPathName = location.pathname;
  const locationPathNameEffective = locationPathName.split("campaign/")[1] || '';

  buttonList.forEach(element => {
    // クリックイベントの対象が<a>タグでない場合は何もしない
    if (element.tagName !== 'A') {
      return;
    }

    // ★★★ ここからクリックイベントハンドラを修正 ★★★
    element.addEventListener("click", (e) => {
      const linkUrl = element.href;

      // --- STEP 1: payloadの組み立てと送信 (常に実行) ---

      // 1-1. まずpayloadの基本形を作成 (トラッキング情報など)
      // これで、リンクの種類に関わらずFirebaseイベントは常に送信対象となる。
      const payload = {
        type: 'BUTTON_TAP',
        firebase: {
          eventName: "mng_user_action",
          actionType: `tap_webview_campaign_detail_/${locationPathNameEffective}`,
          actionValue: element.textContent.trim()
        },
      };

      // 1-2. 次に、リンクのURLに基づいて遷移に関する情報をpayloadに追加
      if (linkUrl && linkUrl !== '#') {
          // ディープリンクの判定
          if (linkUrl.includes("https://minna-no-ginko.go.link/")) {
              try {
                  const url = new URL(linkUrl);
                  const openInnerDeepLinkValue = url.searchParams.get("pg");
                  if (openInnerDeepLinkValue) {
                      payload.openInnerDeepLink = openInnerDeepLinkValue;
                  }
              } catch (error) {
                  console.error("URLの解析に失敗しました:", linkUrl, error);
              }
          }
          // ディープリンクではない外部リンクの判定
          else if (linkUrl.startsWith('http://') || linkUrl.startsWith('https://')) {
              payload.openOuterUrl = linkUrl;
              // reproイベントの追加
              if (element.target === '_blank' && linkUrl.startsWith('https://contact')) {
                  payload.repro = `tap_webview_campaign_detail_/${locationPathNameEffective}_formlink`;
              }
          }
      }

      // 1-3. 組み立てたpayloadをネイティブに送信
      // typeキー以外に何かあれば（firebaseなどがあれば）送信する。
      if (Object.keys(payload).length > 1) {
           sendMessageToNative(payload);
           console.log("ネイティブにpayloadを送信しました:", payload);
      } else {
           console.log("ネイティブに送信するアクションはありませんでした。");
      }


      // --- STEP 2: ブラウザのデフォルト遷移をキャンセルするかどうかの判定 (条件付きで実行) ---

      // ネイティブに処理を委譲すべきか（＝ブラウザのデフォルト遷移を止めるべきか）を判定
      let shouldPreventDefault = false;
      if (linkUrl && linkUrl !== '#') {
        const isExternalUrl = linkUrl.startsWith('http://') || linkUrl.startsWith('https://');

        let hasTpPgQuery = false;
        try {
          const url = new URL(linkUrl, window.location.origin);
          if (url.searchParams.get('tp') === 'pg') {
            hasTpPgQuery = true;
          }
        } catch (error) {
          console.warn("URLの解析に失敗しました:", linkUrl, error);
        }

        // 外部リンクや特定のクエリを持つリンクの場合、デフォルト遷移をキャンセルする
        if (isExternalUrl || hasTpPgQuery) {
          shouldPreventDefault = true;
        }
      }

      // 2-1. 判定結果に応じてpreventDefaultを実行
      if (shouldPreventDefault) {
        e.preventDefault();
        console.log("aタグのデフォルトの画面遷移をキャンセルしました。ネイティブに遷移を委譲します。");
      } else {
        // e.preventDefault()が呼ばれないので、ブラウザが通常の遷移を行う
        console.log("通常のリンクとして扱います。ブラウザが遷移を処理します。");
      }
    });
  });
}

function PageMountSendData () {
  const ApptoWebPath = location.pathname
  const isWebView = ApptoWebPath.includes("/app/apptoweb/")

  // WebViewURLでなければ、何もせずに終了
  if (!isWebView) {
    return;
  }

  let pageSendString = `screen_webview_campaign_detail_${location.pathname}`
  pageSendString = pageSendString.replace("/app/apptoweb/campaign", "");

  const payload = {
    firebase: {
      eventName : "screen_view",
      firebase_screen:pageSendString
    },
    repro: pageSendString,
  }

  sendMessageToNative(payload);
  console.log("送信するpayload:", payload);
}


function MovClickSendData () {

  const ApptoWebPath = location.pathname
  const isWebView = ApptoWebPath.includes("/app/apptoweb/")

  // WebViewURLでなければ、何もせずに終了
  if (!isWebView) {
    return;
  }

  const movList = document.querySelectorAll('[data-controll="mov"]');
  const locationPathName = location.pathname;
  const locationPathNameEffective = locationPathName.split("campaign/")[1] || '';

  movList.forEach(element => {
    element.addEventListener("click", (e) => {
      const youtubeURL = element.querySelector('img[data-youtube]').dataset.youtube
      // 念のため、意図しないデフォルト動作を防ぐ
      e.preventDefault();

      const payload = {
        type: 'BUTTON_TAP',
        openOuterUrl:`https://www.youtube.com/watch?v=${youtubeURL}`,
        firebase: {
          eventName: "mng_user_action",
          actionType: `tap_webview_detail_${locationPathNameEffective}`,
          // alt属性がない場合にエラーにならないよう、安全な取得方法に変更
          actionValue: element.querySelector("img")?.alt || 'mov_click'
        },
      };

      // データ送信のみ行い、画面遷移はしない
      sendMessageToNative(payload);
      console.log("送信するpayload:", payload);
    })
  })
}



export {LinkClickSendData,MovClickSendData,PageMountSendData}
